import React from "react";

function CheckBox(props: any) {
  const { className, checked, ...rest } = props;

  return <>
    <label
      className={['eon-checkbox-label d-flex h-auto bg-eon-red radio', className, checked && 'checked'].join(' ')}
      {...rest}
    />
  </>
}

export default CheckBox